// src/Envelope.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Envelope_default = createIcon({
  displayName: "Envelope",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20 4H4C2.895 4 2 4.895 2 6V18C2 19.105 2.895 20 4 20H20C21.105 20 22 19.105 22 18V6C22 4.895 21.105 4 20 4ZM19.601 8.249L12.53 12.669C12.206 12.872 11.794 12.872 11.47 12.669L4.399 8.249C4.151 8.094 4 7.822 4 7.53C4 6.864 4.733 6.458 5.297 6.811L12 11L18.703 6.811C19.267 6.458 20 6.864 20 7.53C20 7.822 19.849 8.094 19.601 8.249Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Envelope_default
};
